module.exports = __webpack_public_path__ + "media/images/icon__warning@3x-e199fc3837c7c337ba0f4e72e17f17e3.png";